import _ from 'lodash';
import { parseHandleBars } from 'modules/HandlebarsTemplates';
import {
  isMl3App,
  isAndroid,
  isDeviceId,
  isMobile,
} from 'modules/DeviceOptions';
import { resolveLang } from 'common/handleLocale';
import { MapUpdate, MapCreate } from 'modules/API';
import Cookies from 'modules/Cookies';
import { isPresent } from 'ts-is-present';

window.MapCreateImageObj = undefined;
window.MapCreateImageUploadCallback = undefined;
window.MapEditingObj = undefined;

/** @type {string | undefined} */
let selectedMapTemplate;

/**
 * @type
 * {Pick<map, 'alias_map_event_start_datetime' | 'alias_map_event_end_datetime' | 'alias_map_after_play_enabled' | 'alias_map_after_play_start_datetime' | 'alias_map_after_play_no_point_exchange' | 'alias_map_after_play_point_exchange_end_datetime' | 'alias_map_point_name' | 'alias_map_remaining_minute' | 'photo_contest_enabled'>}
 */
let aliasMapConfirmedSetting = {
  alias_map_event_start_datetime: undefined,
  alias_map_event_end_datetime: undefined,
  alias_map_after_play_enabled: false,
  alias_map_after_play_start_datetime: undefined,
  alias_map_after_play_no_point_exchange: false,
  alias_map_after_play_point_exchange_end_datetime: undefined,
  alias_map_point_name: 'Pts',
  alias_map_remaining_minute: 30,
  photo_contest_enabled: false,
  emergency_call: undefined,
  milestone: undefined,
  notes_terms: undefined,
  notes: undefined,
  term: undefined,
  multi_checkin_mission: undefined,
};

// HANDLEBARS
const MapUnpublishAlertTemplate = parseHandleBars(
  resolveLang('「{{this}}」マップを非公開しますか？')
);
const MapPublishAlertTemplate = parseHandleBars(
  resolveLang('「{{this}}」マップを公開しますか？')
);

// ==================================================================
// CATEGORY SELECT
const mapCategorySelector = $('#mapCategorySelector');
const $select2 = mapCategorySelector.select2({
  placeholder: resolveLang('カテゴリ選択'),
  closeOnSelect: false,
  templateResult({ element, text }, container) {
    if (element && container) {
      $(container).addClass($(element).attr('class') || '');
      $(container).data('parent', $(element).data('parent'));
    }
    return text;
  },
  language: {
    noResults() {
      return resolveLang('カテゴリがありません');
    },
  },
});

const select2Interval = setInterval(() => {
  if ($('.select2-search__field').length > 0) {
    $('.select2-search__field').prop('disabled', true);
    clearInterval(select2Interval);
  }
}, 1000);

mapCategorySelector.on('select2:select select2:unselect', (e) => {
  const val = e.params.data.id;
  const order = $select2.data('orderedCollection') || [];
  switch (e.type) {
    case 'select2:select':
      order.push({ lcategory: val });
      break;
    case 'select2:unselect': {
      const index = order
        .map((cat) => {
          return cat.lcategory || cat.category;
        })
        .indexOf(val);
      if (index >= 0) {
        order.splice(index, 1);
      }
      break;
    }
    default:
      break;
  }

  reorderSelect2();
});

/**
 * @param {map['categories']} orderedCollection
 */
function setSelect2(orderedCollection = []) {
  const list = orderedCollection
    .map((map) => {
      return map.lcategory;
    })
    .filter(isPresent);
  mapCategorySelector.data('orderedCollection', orderedCollection);
  mapCategorySelector.val(list).trigger('change');
  reorderSelect2();
}

function reorderSelect2() {
  const $container = $select2.next('.select2-container');
  const $tags = $container.find('li.select2-selection__choice');
  const $input = $tags.last().next();
  const order = mapCategorySelector.data('orderedCollection') || [];

  // apply tag order
  order.forEach((catObj) => {
    const $el = $tags.filter((i, tag) => {
      return tag.title === (catObj.lcategory || catObj.category);
    });
    $input.before($el);
  });
}

// CATEGORY SELECT
// ==================================================================
// ==================================================================

//======================================
//EVENTS
//
$(document).on('click', '.selectMapTemplateModalOpen', (e) => {
  e.preventDefault();
  if (window.accountClass.checkPreviewer()) {
    return;
  }

  window.closeModal();
  const that = e.currentTarget;
  setTimeout(() => {
    window.openModal(`#${$(that).data('modalid')}`);

    // check alias map permission
    if (
      window.AccountUtils.hasPermission(
        window.Gdata.Profile.ori.permissions,
        window.AccountUtils.PERMISSION_MAP_ALIAS
      )
    ) {
      $('.createAliasMapTemplate').addClass('active');
    } else {
      $('.createAliasMapTemplate').removeClass('active');
    }

    if (
      window.AccountUtils.hasPermission(
        window.Gdata.Profile.ori.permissions,
        window.AccountUtils.PERMISSION_SPOT_COLLECTION
      )
    ) {
      $('.createSpotCollectionTemplate').addClass('active');
    } else {
      $('.createSpotCollectionTemplate').removeClass('active');
    }
  }, 400);
});

$(document).on('click', '.createMapModalOpen', (e) => {
  e.preventDefault();

  $('#cmMapName').val('');
  $('#cmMapDesc').val('');
  $('#mapDialySortingSelector').val('0');

  setSelect2([]);

  // @ts-ignore
  document.getElementById('cmPhotoSelect').value = '';
  $('#cmCoverImage').css('background', 'none');
  createMapFlag = 0;
  $('.doCreateMap').html(resolveLang('作成'));
  $('.cmTitle').html($(e.currentTarget).data('templatetitle'));

  if (isMl3App && isAndroid) {
    window.NativeRemoveAllImages();
  }

  selectedMapTemplate =
    MapClass.template[$(e.currentTarget).data('maptemplateindex')];

  if (selectedMapTemplate === MapClass.template.openMap) {
    if (isMl3App && isDeviceId) {
      window.closeModal();
      setTimeout(() => {
        window.openModal('#mDeviceRegister');
      }, 400);
      return;
    }
  }

  resetAliasDetailSettings(
    {
      alias_map_event_start_datetime: undefined,
      alias_map_event_end_datetime: undefined,
      alias_map_after_play_enabled: false,
      alias_map_after_play_start_datetime: undefined,
      alias_map_after_play_no_point_exchange: false,
      alias_map_after_play_point_exchange_end_datetime: undefined,
      alias_map_point_name: 'Pts',
      alias_map_remaining_minute: 30,
      photo_contest_enabled: false,
      emergency_call: undefined,
      milestone: undefined,
      notes_terms: undefined,
      notes: undefined,
      term: undefined,
      multi_checkin_mission: undefined,
    },
    selectedMapTemplate === MapClass.template.aliasMap,
    selectedMapTemplate === MapClass.template.spotCollectionMap,
    true
  );

  window.closeModal();
  const that = e.currentTarget;
  setTimeout(() => {
    window.openModal(`#${$(that).data('modalid')}`);
  }, 400);
});

$(document).on('click', '.doOpenLibrary', function (e) {
  e.preventDefault();

  $('#modalPickerImageOverlay').removeClass('active');
  $('#modalPickerImage').removeClass('active');

  if (window.ml3UploadMode === 1) {
    // Gọi maplife khi chọn từ .ml3AppCreateSpotPhotoSelect
    maplife.showCameraRoll(4);
  } else {
    // Gọi native Android nếu từ .cmPhotoSelect
    window.NativeAndroidShowSingleCameraRoll();
  }
});

$(document).on('click', '.doOpenCamera', function (e) {
  e.preventDefault();

  $('#modalPickerImageOverlay').removeClass('active');
  $('#modalPickerImage').removeClass('active');

  maplife.showCameraRoll(0);
});


$(document).on('click', '#modalPickerImageOverlay', (e) => {
  const $target = $(e.target);
  const $modal = $('#modalPickerImage');

  $('#modalPickerImageOverlay').removeClass('active');
  $modal.removeClass('active');
})


$(document).on('click', '.cmPhotoSelect', () => {
  if (isMl3App && isAndroid) {
    window.ml3UploadMode = 2;
    $('#modalPickerImageOverlay').addClass('active');
    $('#modalPickerImage').addClass('active');
    // window.NativeAndroidShowSingleCameraRoll();
  } else {
    $('#cmPhotoSelect').trigger('click');
  }
});

$('#AliasMapDetailSettingsModal .closeModal').on("click", function () {
  if (!$('.switchOnShowCalendar').hasClass('switchOnShowContainer')) {
    $('.switchOnShowCalendar').addClass('switchOnShowContainer');
  }
});

$(document).on('change', '#cmPhotoSelect', () => {
  /**
   * @type
   * {JQuery<HTMLInputElement>}
   */
  const cmPhotoSelect = $('#cmPhotoSelect');
  if ((cmPhotoSelect.get(0).files || []).length > 1 && !isMobile) {
    cmPhotoSelect.val('');
    setTimeout(() => {
      alert(resolveLang('恐れ入りますが、1 枚だけ選択可能です'));
    }, 300);
  } else {
    //ファイルオブジェクト取得
    const file = (cmPhotoSelect.get(0).files || [])[0];

    //Preview Local Photo
    const preview = $('#cmCoverImage');

    window.loadImage(
      file,
      (img) => {
        preview.css('background', `url('${img.toDataURL()}') no-repeat`);
        preview.css('background-size', 'cover');
        preview.css('background-position', 'center');
      },
      { orientation: true, maxWidth: 600 }
    );
  }
});
$('input[type=radio][name=amAfterPlaySwitch]').change(function() {
  if (this.value == 'false') {
    $('.switchOnShowCalendar').addClass('switchOnShowContainer');
  }
  else if (this.value == 'true') {
    $('.switchOnShowCalendar').removeClass('switchOnShowContainer');
  }
});
$(document).on('click', '.doCreateMap', () => {
  createMap();
});

$(document).on('click', '.doShareMap', (e) => {
  e.stopPropagation();
  e.preventDefault();

  doShareMap($(e.currentTarget).data('mapid'));
});

$(document).on('click', '.doCloseMap', (e) => {
  e.stopPropagation();
  e.preventDefault();

  doShareMap($(e.currentTarget).data('mapid'), true);
});

$(document).on('click', '.doEditMap', (e) => {
  e.stopPropagation();
  e.preventDefault();

  if (window.accountClass.checkPreviewer()) {
    return;
  }

  createMapFlag = 1;
  $('.doCreateMap').html(resolveLang('完了'));
  $('.cmTitle').html(resolveLang('マップを編集'));

  if (
    window.Gdata.CurrentMap.ori &&
    window.Gdata.CurrentMap.ori[0] &&
    window.Gdata.CurrentMap.ori[0].is_lifemap === '1'
  ) {
    window.disableElm($('#cmMapName'));
  }

  const map = window.Gdata.CurrentMap.ori[0];
  $('#cmMapName').val(map.title);
  $('#cmMapDesc').val(map.description);
  if (map.mapcode_flag == '1') {
    $('#showMapCode').removeClass('active');
  }
  if (map.heatmap_flag == '1') {
    $('#showHeatMap').removeClass('active');
  }
  let dialy_order = '0';
  if (map.dialy_order) {
    dialy_order = map.dialy_order;
  }
  $('#mapDialySortingSelector').val(dialy_order);

  resetAliasDetailSettings(
    {
      alias_map_event_start_datetime: map.alias_map_event_start_datetime,
      alias_map_event_end_datetime: map.alias_map_event_end_datetime,
      alias_map_after_play_enabled: map.alias_map_after_play_enabled,
      alias_map_after_play_start_datetime:
        map.alias_map_after_play_start_datetime,
      alias_map_after_play_no_point_exchange:
        map.alias_map_after_play_no_point_exchange,
      alias_map_after_play_point_exchange_end_datetime:
        map.alias_map_after_play_point_exchange_end_datetime,
      alias_map_point_name: map.alias_map_point_name,
      alias_map_remaining_minute: 30,
      photo_contest_enabled: map.photo_contest_enabled,
      emergency_call: map.emergency_call,
      milestone: map.milestone,
      notes_terms: map.notes_terms,
      notes: map.notes,
      term: map.term,
      multi_checkin_mission: map.multi_checkin_mission,
    },
    map.template_id === MapClass.template.aliasMap,
    map.template_id === MapClass.template.spotCollectionMap,
  );
  selectedMapTemplate = map.template_id;

  /**
   * @type
   * {JQuery<HTMLInputElement>}
   */
  const cmPhotoSelect = $('#cmPhotoSelect');
  if (cmPhotoSelect) {
    cmPhotoSelect.val('');
  }
  const imageSrc = `${window.ImageDomainURLRead}thumbnail/${map.image_id}`;
  $('#cmCoverImage').css('background', `url("${imageSrc}") no-repeat`);
  $('#cmCoverImage').css('background-size', 'cover');
  $('#cmCoverImage').css('background-position', 'center');

  setSelect2($.extend([], map.categories));

  window.openModal('#CreateMapModal');

  $('#cmCoverImageImg').data('imageid', map.image_id);
  $('#cmCoverImageImg').attr('src', imageSrc);
});

$(document).on('click', '.aliasMapDetailButton', (e) => {
  $('#amEventStartDateTime')
    .data('DateTimePicker')
    .date(
      aliasMapConfirmedSetting.alias_map_event_start_datetime
        ? window.moment
            .utc(
              aliasMapConfirmedSetting.alias_map_event_start_datetime,
              'YYYY-MM-DD HH-mm-ss'
            )
            .local()
        : null
    );
  $('#amEventEndDateTime')
    .data('DateTimePicker')
    .date(
      aliasMapConfirmedSetting.alias_map_event_end_datetime
        ? window.moment
            .utc(
              aliasMapConfirmedSetting.alias_map_event_end_datetime,
              'YYYY-MM-DD HH-mm-ss'
            )
            .local()
        : null
    );
  $(
    `#${
      aliasMapConfirmedSetting.alias_map_after_play_enabled
        ? 'afterPlayOn'
        : 'afterPlayOff'
    }`
  ).prop('checked', true);
  if (aliasMapConfirmedSetting.alias_map_after_play_enabled && $('.switchOnShowCalendar').hasClass('switchOnShowContainer')) {
    $('.switchOnShowCalendar').removeClass('switchOnShowContainer');
  }
  $('#amAfterPlayStartDateTime')
    .data('DateTimePicker')
    .date(
      aliasMapConfirmedSetting.alias_map_after_play_start_datetime
        ? window.moment
            .utc(
              aliasMapConfirmedSetting.alias_map_after_play_start_datetime,
              'YYYY-MM-DD HH-mm-ss'
            )
            .local()
        : null
    );
  $('#amAfterPlayNoPointExchange').prop(
    'checked',
    aliasMapConfirmedSetting.alias_map_after_play_no_point_exchange
  );
  $('#amAfterPlayPointExchangeEndDateTime')
    .data('DateTimePicker')
    .date(
      aliasMapConfirmedSetting.alias_map_after_play_point_exchange_end_datetime
        ? window.moment
            .utc(
              aliasMapConfirmedSetting.alias_map_after_play_point_exchange_end_datetime,
              'YYYY-MM-DD HH-mm-ss'
            )
            .local()
        : null
    );
  $('#amPointName').val(aliasMapConfirmedSetting.alias_map_point_name);
  $('#phoneNumber').val(aliasMapConfirmedSetting.emergency_call);
  if (selectedMapTemplate === MapClass.template.spotCollectionMap) {
      $('.inputPointPrev').css("display", "block");
        if (aliasMapConfirmedSetting.milestone != "undefined" ) {
          $('#predeterminedPoints').val(aliasMapConfirmedSetting.milestone);
        }
    } else {
      $('.inputPointPrev').css("display", "none");
    };
  $("input[name=attentionTerms][value=" + aliasMapConfirmedSetting.notes_terms + "]").attr('checked', 'checked');
  $("input[name=repeatMission][value=" + aliasMapConfirmedSetting.multi_checkin_mission + "]").attr('checked', 'checked');
  $('#editPrecautionsTextArea').val(aliasMapConfirmedSetting.notes);
  $('#editTermTextArea').val(aliasMapConfirmedSetting.term);
  $(
    `#${
      aliasMapConfirmedSetting.photo_contest_enabled
        ? 'photoContestOn'
        : 'photoContestOff'
    }`
  ).prop('checked', true);

  window.openModal(`#${$(e.currentTarget).data('modalid')}`);
});
$(document).on('click', '.btnTermModalOpen', (e) => {
   window.openModal(`#${$(e.currentTarget).data('modalid')}`);
});

// save data
$(document).on('click', '.aliasMapDetailConfirmBtn', () => {
  /** @type {string[]} */
  const errors = [];

  const alias_map_event_start_datetime = $('#amEventStartDateTime')
    .data('DateTimePicker')
    .date()
    ? $('#amEventStartDateTime')
        .data('DateTimePicker')
        .date()
        .set({ second: 0 })
        .utc()
        .format('YYYY-MM-DD HH-mm-ss')
    : null;
  if (!alias_map_event_start_datetime) {
    errors.push(resolveLang('- 開催日時を設定してください。'));
  }

  const alias_map_event_end_datetime = $('#amEventEndDateTime')
    .data('DateTimePicker')
    .date()
    ? $('#amEventEndDateTime')
        .data('DateTimePicker')
        .date()
        .set({ second: 0 })
        .utc()
        .format('YYYY-MM-DD HH-mm-ss')
    : null;
  if (!alias_map_event_end_datetime) {
    errors.push(resolveLang('- 終了日時を設定してください。'));
  }

  if (String($('#amPointName').val()).length > 7) {
    errors.push(resolveLang('- ポイント名称は７文字以下で入力してください。'));
  }

  if ($('input[name=amAfterPlaySwitch]:checked').val() === 'true') {
    // フリープレイONの場合
    if (!$('#amAfterPlayStartDateTime').data('DateTimePicker').date()) {
      errors.push(resolveLang('- フリープレイ開始日時を設定してください。'));
    }
  }

  if (errors.length) {
    alert(errors.join('\n'));
    return;
  }

  aliasMapConfirmedSetting.alias_map_event_start_datetime = alias_map_event_start_datetime;
  aliasMapConfirmedSetting.alias_map_event_end_datetime = alias_map_event_end_datetime;
  aliasMapConfirmedSetting.alias_map_after_play_enabled =
    $('input[name=amAfterPlaySwitch]:checked').val() === 'true';
  aliasMapConfirmedSetting.alias_map_after_play_start_datetime = $(
    '#amAfterPlayStartDateTime'
  )
    .data('DateTimePicker')
    .date()
    ? $('#amAfterPlayStartDateTime')
        .data('DateTimePicker')
        .date()
        .set({ second: 0 })
        .utc()
        .format('YYYY-MM-DD HH-mm-ss')
    : null;
  aliasMapConfirmedSetting.alias_map_after_play_no_point_exchange = $(
    '#amAfterPlayNoPointExchange'
  ).prop('checked');
  aliasMapConfirmedSetting.alias_map_after_play_point_exchange_end_datetime = $(
    '#amAfterPlayPointExchangeEndDateTime'
  )
    .data('DateTimePicker')
    .date()
    ? $('#amAfterPlayPointExchangeEndDateTime')
        .data('DateTimePicker')
        .date()
        .set({ second: 0 })
        .utc()
        .format('YYYY-MM-DD HH-mm-ss')
    : null;
  aliasMapConfirmedSetting.alias_map_point_name = String(
    $('#amPointName').val()
  );
  aliasMapConfirmedSetting.emergency_call = String(
    $('#phoneNumber').val()
  );

  if (selectedMapTemplate === MapClass.template.spotCollectionMap) {
    aliasMapConfirmedSetting.milestone = String(
        $('#predeterminedPoints').val()
      );
  }
  
  aliasMapConfirmedSetting.notes = String(
    $('#editPrecautionsTextArea').val()
  );
  aliasMapConfirmedSetting.term = String(
    $('#editTermTextArea').val()
  );
  aliasMapConfirmedSetting.photo_contest_enabled =
    $('input[name=photoContestSwitch]:checked').val() === 'true';
  aliasMapConfirmedSetting.notes_terms = $('input[name=attentionTerms]:checked').val();
  aliasMapConfirmedSetting.multi_checkin_mission  = $('input[name=repeatMission]:checked').val();

  window.closeModal();
  $('.doCreateMap').removeAttr('disabled');
});

let createMapFlag = 0;

//======================================
//FUNCTIONS
//
/**
 *
 * @param {typeof aliasMapConfirmedSetting} obj
 * @param {*} show
 */
function resetAliasDetailSettings(obj, show = false, showSpot = false, disableBtn = false) {
  // alias map
  if (show || showSpot) {
    $('.aliasMapDetailButton').show();
    if (showSpot) {
      $('.subSpotCollect').show();
      $('.subAllias').hide();
    } else if(show) {
      $('.subSpotCollect').hide();
      $('.subAllias').show();
    }
    if (disableBtn) {
      $('.doCreateMap').attr('disabled', 'disabled');
    }

    aliasMapConfirmedSetting = obj;
  } else {
    $('.aliasMapDetailButton').hide();
    $('.doCreateMap').removeAttr('disabled');
  }
}

function createMap() {
  window.freezeModal('#CreateMapModal');
  window.disableElm('.doCreateMap');

  /**
   * @type
   * {Parameters<typeof MapUpdate>[0]}
   */

  var stateMapCode = (!$('#showMapCode').hasClass('active') && $('#showMapCode').length) ? '1' : 'null';
  var stateHeatMap = (!$('#showHeatMap').hasClass('active') && $('#showHeatMap').length) ? '1' : 'null';
  let mapObj = {
    title: $('#cmMapName').val(),
    description: $('#cmMapDesc').val(),
    dialy_order: $('#mapDialySortingSelector').val(),
    mapcode_flag: stateMapCode,
    heatmap_flag: stateHeatMap,
  };

  // ==========================================
  // category
  mapObj.categories = mapCategorySelector.data('orderedCollection') || [];
  // filter category
  mapObj.categories = _.filter(mapObj.categories, ({ lcategory }) => {
    if (!lcategory) {
      return false;
    }
    return !!window.CONFIG_ARR.map.categories[lcategory];
  });

  // // remove parent categories
  // mapObj.categories = mapObj.categories.filter(function(map){
  //  return map.category;
  // });
  // // reselect parent categories
  // var copy = _.map(CONFIG_ARR.map.categories, _.clone);
  // _.forEach(mapObj.categories, function(selectedCat){
  //  if (copy.length <= 0) {
  //    return false;
  //  }

  //  _.forEach(copy, function(lcat, index){
  //    var contains = _.includes(lcat.childCategories, selectedCat.category);
  //    if (contains) {
  //      copy.splice(index, 1);
  //      mapObj.categories.push({ lcategory: lcat.title });
  //      return false;
  //    }
  //  });
  // });
  // // remove duplicates
  // mapObj.categories = _.uniqBy(mapObj.categories, function(obj){
  //  return obj.lcategory || 'category'+obj.category;
  // });
  // mapObj.categories = _.uniqBy(mapObj.categories, function(obj){
  //  return obj.category || 'lcategory'+obj.lcategory;
  // });
  // ==========================================

  if (createMapFlag === 1) {
    const currentMap = window.Gdata.CurrentMap.ori[0];
    if (MapClass.checkShared(currentMap.share_id)) {
      if (
        !mapObj.categories ||
        !mapObj.categories.find((obj) => {
          return obj.lcategory;
        })
      ) {
        window.unfreezeModal('#CreateMapModal');
        window.enableElm('.doCreateMap');
        return alert(resolveLang('マップのカテゴリを選択してください'));
      }

      if (
        currentMap.lang_edited &&
        (mapObj.title !== currentMap.title ||
          mapObj.description !== currentMap.description)
      ) {
        if (
          !confirm(
            resolveLang(
              '日本語以外で手動で編集した翻訳データーは削除されます。よろしいですか？'
            )
          )
        ) {
          window.unfreezeModal('#CreateMapModal');
          window.enableElm('.doCreateMap');
          return;
        }
      }
    }

    if (mapObj.title === currentMap.title) {
      delete mapObj.title;
    }
    if (mapObj.description === currentMap.description) {
      delete mapObj.description;
    }

    if (currentMap.template_id === MapClass.template.aliasMap || currentMap.template_id === MapClass.template.spotCollectionMap) {
      mapObj = {
        ...mapObj,
        ...aliasMapConfirmedSetting,
      };
    }
  } else if (selectedMapTemplate) {
    //init template - and template can't be changed
    mapObj.template_id = selectedMapTemplate;
    if (selectedMapTemplate === window.MapClass.template.openMap) {
      mapObj.share_id = window.MapClass.share_id.closed_share;
    }

    if (mapObj.template_id === MapClass.template.aliasMap || mapObj.template_id === MapClass.template.spotCollectionMap) {
      mapObj = {
        ...mapObj,
        ...aliasMapConfirmedSetting,
      };
    }
  }

  if (mapObj.title === '') {
    alert(resolveLang('マップのタイトルを入力してください'));
    window.unfreezeModal('#CreateMapModal');
    window.enableElm('.doCreateMap');
    return;
  }

  mapObj.session = Cookies.get(CookieSession);

console.log('*****************************************************');
console.log('heatmap_flag = ' + stateHeatMap);
// create map
  const UploadMapHere = async () => {
    try {
      const resultMap =
        createMapFlag === 1
          ? await MapUpdate({
              ...mapObj,
              _id: window.Gdata.CurrentMap.ori[0]._id,
            })
          : await MapCreate({
              ...mapObj,
              title: String(mapObj.title),
              description: String(mapObj.description),
            });

      window.location.href = `/maps/archive/${resultMap._id}`;
    } catch (error) {
      console.log(error);
      window.unfreezeModal('#CreateMapModal');
      window.enableElm('.doCreateMap');
    }
  };

  /**
   * @type
   * {JQuery<HTMLInputElement>}
   */
  const cmPhotoSelect = $('#cmPhotoSelect');
  if (isMl3App && isAndroid) {
    if (window.MapCreateImageObj) {
      window.MapEditingObj = mapObj;
      window.MapCreateImageUploadCallback = UploadMapHere;
      window.NativeUploadImages();
    } else {
      UploadMapHere();
    }
  } else if ((cmPhotoSelect.get(0).files || []).length > 0) {
    //Check and Upload Photo first
    //upload here
    window.registPicture({
      file: (cmPhotoSelect.get(0).files || [])[0],
      checkSpot:'MapCreate',
      ajaxRequest: window.myPhotoAjaxRequest,
      success(data) {
        // var data = {"code":"S0000","fileids":[{"file":"gmgzFjx.jpg","fileid":"d_6d74311c5ffd4800c86e0bfbf52fb0483242b649\/f_0000000000_dc71742f810dd104c97661bc0b9099be5b18e966.jpg"}]};
        if (data.code === 'S0000') {
          mapObj.image_id = data.fileids[0].fileid;
          UploadMapHere();
        } else {
          UploadMapHere();
        }
      },
      error() {
        alert(resolveLang('写真アップロードに失敗しました'));
        UploadMapHere();
      },
    });
  } else {
    UploadMapHere();
  }
}

/**
 * @param {string} mapID
 * @param {boolean | undefined} [close]
 */
const doShareMap = async (mapID, close) => {
  if (isMl3App && isDeviceId) {
    window.openModal('#mDeviceRegister');
    return;
  }

  if (window.accountClass.checkPreviewer()) {
    return;
  }

  if (mapID) {
    if (
      window.Gdata.MyMaps.loaded === 2 &&
      window.Gdata.MyMaps.dic &&
      window.Gdata.MyMaps.dic[mapID]
    ) {
      const map = window.Gdata.MyMaps.dic[mapID];

      if (map.is_lifemap === '1') {
        return alert(resolveLang('「ライフマップ」は公開できません！'));
      }

      let proceed = false;

      if (close) {
        const editLangWarning = map.lang_edited
          ? `（${resolveLang(
              '日本語以外で手動で編集した翻訳データーは削除されます。よろしいですか？'
            )}）`
          : '';
        proceed = confirm(
          MapUnpublishAlertTemplate(map.title) + editLangWarning
        );
      } else {
        if (!map.image_id || map.image_id === null || map.image_id === '') {
          alert(
            resolveLang(
              'このマップを公開するには、マップの画像を設定してください!'
            )
          );
          return;
        }

        if (
          !map.categories ||
          !map.categories.find((obj) => {
            return obj.lcategory;
          })
        ) {
          return alert(
            resolveLang(
              'このマップを公開するには、マップのカテゴリを選択してください!'
            )
          );
        }

        proceed = confirm(MapPublishAlertTemplate(map.title));
      }

      if (!proceed) {
        return;
      }

      /** @type {Parameters<typeof MapUpdate>[0]} */
      const mapObj = {
        _id: map._id,
        session: Cookies.get(CookieSession),
      };
      if (close) {
        mapObj.share_id =
          mapObj.template_id === window.MapClass.template.openMap
            ? window.MapClass.share_id.closed_share
            : window.MapClass.share_id.closed;
      } else {
        mapObj.share_id =
          mapObj.template_id === window.MapClass.template.openMap
            ? window.MapClass.share_id.shared
            : window.MapClass.share_id.open;
      }

      try {
        const result = await MapUpdate(mapObj);
        // success
        const oriObj = window.Gdata.MyMaps.dic[mapID];
        // eslint-disable-next-line no-restricted-syntax
        for (const index in result) {
          if (result[index]) {
            // @ts-ignore
            oriObj[index] = result[index];
          }
        }
        if (
          mapObj.share_id === MapClass.share_id.closed_share ||
          mapObj.share_id === MapClass.share_id.closed
        ) {
          delete oriObj.lang;
        }
        window.PopulateAndSortByUpdateDatetime(window.Gdata.MyMaps.ori);
        window.APIGetMyMaps({
          htmlTemplate: 'myMapListInnerTemplate',
        });

        if (
          window.Gdata.CurrentMap.dic &&
          window.Gdata.CurrentMap.dic[mapObj._id || '']
        ) {
          window.Gdata.CurrentMap.dic[mapObj._id || ''].share_id =
            mapObj.share_id;
          //reload wall
          window.setCurrentMap();
        }

        //profile page
        if (window.ProfilePage) {
          window.ProfilePage.reset();
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
// Validation
// Restricts input for the given textbox to the given inputFilter.
function setInputFilter(textbox, inputFilter) {
  ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
    textbox.addEventListener(event, function() {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  });
}
setInputFilter(document.getElementById("phoneNumber"), function(value) {
  return /^\d*$/.test(value) && (value === "" || parseInt(value) <= 999999999999);
});
setInputFilter(document.getElementById("predeterminedPoints"), function (value) {
  return /^\d*$/.test(value) && (value === "" || parseInt(value) <= 999999999999);
});